// src/data/webinars.ts
//
// Source de vérité (côté frontend) pour les webinaires affichés sur webinaires.html.
// Les liens Zoom NE sont PAS ici : ils vivent uniquement côté backend
// (cryptoaccounting-api/webinar-config.js) pour éviter le scraping.

export type Webinar = {
  id: string;
  title: string;
  dateLabel: string;
  dateISO: string;
  timeLabel: string;
  audience: string;
};

export const WEBINARS: Webinar[] = [
  {
    id: 'w1-declarer-particuliers',
    title: 'Déclarer ses crypto-actifs sans erreur',
    dateLabel: '7 mai 2026',
    dateISO: '2026-05-07T13:00:00+02:00',
    timeLabel: '13h00 (30 min)',
    audience: 'Particuliers',
  },
  {
    id: 'w2-mica-dac8',
    title: 'MiCA et DAC8 : ce que ça change concrètement',
    dateLabel: '10 juin 2026',
    dateISO: '2026-06-10T13:00:00+02:00',
    timeLabel: '13h00 (30 min)',
    audience: 'Cabinets & entreprises',
  },
  {
    id: 'w3-comptabiliser-entreprise',
    title: 'Comptabiliser les crypto-actifs en entreprise',
    dateLabel: '1er juillet 2026',
    dateISO: '2026-07-01T13:00:00+02:00',
    timeLabel: '13h00 (30 min)',
    audience: 'Entreprises & DAF',
  },
];

export function getWebinarById(id: string | null | undefined): Webinar | null {
  if (!id) return null;
  return WEBINARS.find((w) => w.id === id) || null;
}
